// get_product_innovation_categories
export const GET_PRODUCT_SUBCATEGORIES = 'get_product_innovation_categories';
export const GET_PRODUCT_SUBCATEGORIES_SUCCESSFUL =
  'get_product_innovation_categories_successfull';
export const GET_PRODUCT_SUBCATEGORIES_FAILED =
  'get_product_innovation_categories_failed';

// create_product_innovation_category
export const CREATE_PRODUCT_INNOVATION_CATEGORY =
  'create_product_innovation_category';
export const CREATE_PRODUCT_INNOVATION_CATEGORY_SUCCESSFUL =
  'create_product_innovation_category_successfull';
export const CREATE_PRODUCT_INNOVATION_CATEGORY_FAILED =
  'create_product_innovation_category_failed';

// update_product_innovation_category
export const UPDATE_PRODUCT_INNOVATION_CATEGORY =
  'update_product_innovation_category';
export const UPDATE_PRODUCT_INNOVATION_CATEGORY_SUCCESSFUL =
  'update_product_innovation_category_successfull';
export const UPDATE_PRODUCT_INNOVATION_CATEGORY_FAILED =
  'update_product_innovation_category_failed';

// delete_product_innovation_category
export const DELETE_PRODUCT_INNOVATION_CATEGORY =
  'delete_product_innovation_category';
export const DELETE_PRODUCT_INNOVATION_CATEGORY_SUCCESSFUL =
  'delete_product_innovation_category_successfull';
export const DELETE_PRODUCT_INNOVATION_CATEGORY_FAILED =
  'delete_product_innovation_category_failed';
